import { ConditionalWrapper, Tooltip } from '@arnold/common';
import styled from '@emotion/styled';
import { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

type ReportPendingApprovalTooltipProps = {
  isPending?: boolean | null;
  children: ReactElement;
};

export const ReportPendingApprovalTooltip: FC<ReportPendingApprovalTooltipProps> = ({ isPending, children }) => {
  const [t] = useTranslation('surveyOverviewRow');

  return (
    <ConditionalWrapper
      condition={!!isPending}
      wrapper={(wrapped) => (
        <InlineTooltip title={t('reportPendingApprovalTooltip')}>
          <Trigger>{wrapped}</Trigger>
        </InlineTooltip>
      )}
    >
      {children}
    </ConditionalWrapper>
  );
};

const InlineTooltip = styled(Tooltip)`
  display: inline-flex !important;
  align-items: center;
`;

const Trigger = styled.span`
  display: inline-flex;
  align-items: center;
`;
